/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tooltip_governance_council = () => `Council governance is similar to the operational structure of boards of directors in traditional web2 companies. It involves a selected group of organizations or individuals responsible for determining the blockchain's future, strategy, and allocation of funds.`
